<template>
  <div>
    <base-material-card-list :item='item' ref="table">
      <template v-slot:content="{ records, loading }">
        <v-card-text class="white rounded-lg">
          <slot name='conditions' :records="records" :loading='loading'></slot>
        </v-card-text>
        <div class="my-3">
          <v-row>
            <v-col cols="12" md='3' v-for="(i, idx) in records" :key="idx">
              <v-hover v-slot="{ hover }">
                <v-card  class="rounded-lg" :elevation="hover ? 1 : 0" >
                  <v-app-bar flat color="white" height="50" class="pr-n1">
                    <v-toolbar-title class="font-weight-bold size-15 pl-0">
                      {{i.title}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn text dark fab small @click="detailModal = { show: true, data: i }">
                      <v-icon color="grey">mdi-eye</v-icon>
                    </v-btn>
                  </v-app-bar>
                  <v-card-subtitle class="py-0">
                     <v-chip label class="mr-1 px-1" dark color="green lighten-1" x-small>
                        <span class="font-weight-bold">{{i.typeDic.name}}</span>
                      </v-chip>
                      <v-chip label class="mr-1 px-1" dark color="blue lighten-1" x-small>
                        <span class="font-weight-bold">{{i.startMonth}}月~{{i.endMonth}}月申报</span>
                      </v-chip>
                      <v-chip label class="mr-1 px-1" dark color="pink lighten-1" x-small>
                        <span class="font-weight-bold">{{i.area || '全国'}}</span>
                      </v-chip>
                  </v-card-subtitle>

                  <v-card-text class="text--grey my-3">
                    {{ i.publishTime | formatDay }} 发布
                  </v-card-text>

                  <v-card-actions>
                    <slot name='actions' :row='i' :idx="idx"></slot>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" small text @click="show(idx)" v-if="item.showMore">
                      <v-icon>{{ idx === showIdx ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>{{ idx === showIdx ? '关闭' : '更多' }}
                    </v-btn>
                  </v-card-actions>
                  <v-expand-transition v-if="idx === showIdx">
                    <div>
                      <v-divider></v-divider>
                      <v-card-text class="py-1">
                        <span> 其他要求：</span>
                        <div class="green--text" v-for="(i, inx) in i.seniorityList" :key="inx">
                          ({{ inx+1 }}) {{ i}}
                        </div>
                        <div class="mt-1" v-if="i.abstracts">政策描述：</br>
                          <span class="grey--text " style="white-space:pre-wrap">{{ i.abstracts }}</span>
                        </div>
                      </v-card-text>
                    </div>
                  </v-expand-transition>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </div>
      </template>
    </base-material-card-list>
    <detail-view :item='detailModal'></detail-view>
  </div>
</template>

<script>

  import DetailView from './Detail.vue'

  export default {
    name: 'PolicyList',
    components: {
      DetailView
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          showMore: false,
          path: '',
          topButtons: [],
          params: {}
        })
      }
    },
    data() {
      return {
        showIdx: -1,
        detailModal: { show: false }
      }
    },
    methods: {
      show (idx) {
        this.showIdx = this.showIdx === idx ? -1 : idx
      },
      doDelete (item) {
        this.$refs.table.doDelete(item)
      },
      loadData () {
        this.$refs.table.loadData()
      },
    }
  }
</script>

<style>
.label-chip{
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
}
</style>
